module.exports = __webpack_public_path__ + "img/mayBanner_460.88026aa9.png";